var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: " bg-white" },
    [
      _c("full-calendar", {
        ref: "calendar",
        attrs: { config: _vm.config, events: _vm.calendarEvents },
      }),
      _c("MyCalendarForm", {
        ref: "myCalendarForm",
        attrs: { start: _vm.start, end: _vm.end },
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }